const alertDismissible = {
  props: {
    dismissible:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isClosed: false,
    };
  },
  methods: {
    close() {
      this.isClosed = true;
    },
  },
  computed: {
    showAlertClass() {
      return this.isClosed ? "hide-important" : "show";
    },
    dismissibleClass() {
      return this.dismissible ? "alert-dismissible" : "";
    },
  }
};
